import { render, staticRenderFns } from "./CurrentSupplierMessage.vue?vue&type=template&id=6eeae3b7&"
import script from "./CurrentSupplierMessage.vue?vue&type=script&lang=js&"
export * from "./CurrentSupplierMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports